import { ChiTietBaoHiem } from "../baohiem/BaoHiem";


export class TongHopThuNhap {
    "id": number
    "thang": Date;
    "trangThai": number;
    "luongTamUngNQL"?: number;
    "thuNhapNLD": number;
    "thuNhapNQL": number;
    "tongThuNhap": number;
    "dsLuongNLD": Array<ThuNhapNldVM>;
    "dsLuongNQL": Array<ThuNhapLdVM>;
    "luongVCQL": Array<LuongVCQL>;
    "luongNLD": Array<LuongNLD>;
    "luongPhuCap": Array<luongPhuCap>;
    "luongThuNhapNLD": Array<LuongNhanVien>;
    "luongThuNhapVCQL": Array<LuongNhanVien>;
    "tongHopLuongVCQL": Array<TongHopLuong>;
    "tongHopLuongNLD": Array<TongHopLuong>;
    "baoHiem": Array<ChiTietBaoHiem>;
    "chamCong": Array<any>;
    "trangThaiDuyetLuong": number;
    "idLuongTamTinh": number;
    "chiTietLuongThang": ChiTietLuongThanhPhan;
    "chiTietDynamic": Array<CotThongTinChiTietLuong>
    "thangChiTra": Date | null;
}

export class CotThongTinChiTietLuong {
    "id": number;
    "loai": number;
    "ten": string;
    "duLieu": Array<any>;
    "phanLoai": number;
}

export class LuongVCQL {
    "idNhanVien": number;
    "idChucVu": number;
    "idHeSoLuong": number;
    "hoTen": string;
    "chucVu": string;
    "soNgayCongTinhLuong": number;
    "congThang": number;
    "mucLuongTheoChucDanh": number;
    "mucLuongTheoHDLD": number;
    "giamCongDoan": number;
    "giamBHXH": number
    "luongKhac": number;
    "luongConNhan": number;
    "luongDaNhan": number;
    "ghiChu":string
}

export class LuongNLD {
    "idNhanVien": number;
    "idHeSoLuong": number;
    "idChucVu": number;
    "hoTen": string;
    "chucVu": string;
    "bacLuongChuyenVien": string;
    "bacLuongCanSu": string;
    "bacLuongNhanVien": string;
    "mucLuongTheoHDLD": number;
    "mucPhuCapChucVu": number;
    "tienLuongDongBHXH": number;
    "xepLoai": string;
    "heSoXepLoai": number;
    "soNgayCongTinhLuong": number;
    "luongThucNhan": number;
    "giamCongDoan": number;
    "giamBHXH": number;
    "luongKhac": number;
    "luongConNhan": number;
    "luongDaNhan": number;
    "ghiChu": string
}

export class luongPhuCap {
    "hoTen": string;
    "chucVu": string;
    "soNgayCong": number;
    "chiAnCa": number;
    "thanhTienAnCa": number;
    "mucKhoanDienThoai": number;
    "mucKhoanCTP": number;
    "isQuanLy": boolean;
    "ghiChu": string;
    "idNhanVien": number;
    "idChucVu": number;
    "idPhuCapAnCa": number;
    "idPhuCapDienThoai": number;
    "idPhuCapCTP": number;
}

export class LuongNhanVien {
    "hoTen": string;
    "chucVu": string;
    "luongCoBan": number;
    "luongPhuCap": number;
    "luongThemGio": number;
    "luongKhac": number;
    "tongThuNhap": number;
    "ghiChu": string;
}

export class ThuNhapNldVM {
    "maNhanVien": string;
    "tenDonVi": string;
    "hoTen": string;
    "chucVu": string;
    "tienLuong": number;
    "phuCap": number;
    "luongThemGio": number;
    "thuNhapKhac": number;
    "tienThucNhan": number
}

export class ThuNhapLdVM {
    "tenDonVi": string;
    "maNhanVien": string;
    "hoTen": string;
    "chucVu": string;
    "tienLuong": number;
    "phuCap": number;
    "thuLaoNDD": number;
    "thuNhapKhac": number;
    "tienThucNhan": number
}
export class LuongDataTable {
    "loai": number;
    "thang": number;
    "nam": number;
    "tenKyLuong": string;
    "tongthuNhapNQL": number;
    "tongthuNhapNLD": number;
    "trangThai": number;
    "ngayCapNhat": Date;
};


export class NhanVien_MucLuong_PhuCap {
    "idNhanVien": number;
    "mucLuongBHXH": number;
    "phuCapChucVu": number;
    "id": number;
    "hoTen": string;
    "idChucVu": number;
    "tenChucVu": string;
    "idDonVi": number;
    "tenDonVi": string;
    "mucThuNhap": number;
    "maNhanVien": string;
    "idNhom": number;
    "tenNhom": number;
    "thuTuStr": string;
    "ghiChu": string;
    "dynamicColumns"?: Record<string, number>;
};

export class ChiTietPhatSinhTinhThueResponse {
    "ten": string;
    "thangNam": Date;
    "loai": number;
    "loaiUngHo": number;
    "khoaDieuChinh": number;
    "mucTrungBinh": number;
    "id": number;
    "isApDungToanBo": boolean;
    "dsNhanVien": Array<NhanVien_MucLuong_PhuCap>;
    "dynamicColumnNames"?: Array<string>;
}

export class DanhSachKhenThuongUngHoResponse {
    "thang": number;
    "nam": number;
    "thoiGian": string;
    "ten": string;
    "loai": number;
    "loaiUngHo": number;
    "khoaDieuChinh": number;
    "id": number;
    "soLuongCBCNV": number;
    "tongSoTien": number;
};

export class ChiTietKhenThuongUngHoResponse {
    "ten": string;
    "thangNam": Date;
    "loai": number;
    "loaiUngHo": number;
    "khoaDieuChinh": number;
    "mucTrungBinh": number;
    "id": number;
    "isApDungToanBo": boolean;
    "dsNhanVien": Array<NhanVien_MucLuong_PhuCap>
}

export class TongHopLuong {
    "hoTen": string;
    "chucVu": string;
    "luongCoBan": number;
    "luongDaNhan": number;
    "luongPhuCap": number;
    "luongThemGio": number;
    "luongKhac": number;
    "luongKhacCoBan": number;
    "tongThuNhap": number;
    "luongAm": number;
    "daTruyThu": number;
    "ghiChu": string;
    "idChucVu": number;
    "bacLuongChuyenVien": string;
    "bacLuongCanSu": string;
    "bacLuongNhanVien": string;
    "mucLuongTheoHDLD": number;
    "mucPhuCapChucVu": number;
    "tienLuongDongBHXH": number;
    "xepLoai": string;
    "heSoXepLoai": number;
    "soNgayCongTinhLuong": number;
    "luongThucNhan": number;
    "giamCongDoan": number;
    "giamBHXH": number;
    "luongConNhan": number;
    "idNhanVien": number;
    "idHeSoLuong": number
    "congThang": number;
    "mucLuongTheoChucDanh": number;
}

export class DsOptionsLuongThanhPhan {
    "optionLuongBSNQL": Array<OptionLuongThanhPhan>;
    "optionBHXH": Array<OptionLuongThanhPhan>;
    "optionLuongTTNLD": Array<OptionLuongThanhPhan>;
    "optionLuongPhatSinh":Array<OptionLuongThanhPhan>;
    "optionLuongNDD":Array<OptionLuongThanhPhan>;
}

export class OptionLuongThanhPhan {
    "ten": string;
    "id": number;
    "coNguoiDatMucToiThieu"?: boolean;
}

export class ChiTietLuongThanhPhan {
    "thang": number;
    "nam": number;
    "loai": number;
    "dsLuongBS_NQL": Array<number>;
    "dsBHXH": Array<number>;
    "dsLuongTT_NLD": Array<number>;
    "dsLuongPhatSinh": Array<number>;
    "dsLuongNDD": Array<number>;
}

export class ImportFileLPS {
    "file": FormData;
    "thoiGian": any;
}

export class LuongThangInfo {
    "id": number;
    "thangNam": Date;
    "congThang": number;
    "dot"?: number;
    "trangThai": number;
    "tenKyLuong": string;
    "ghiChu"?: string;
    "dsIdBaoHiemThang": number[];
    "dsIdLuongKhenThuongUngHo": number[];
    "dsIdLuongCoBan": number[];
    "dsIdLuongPhuCap": number[];
    "dsIdLuongThemGio": number[];
    "dsIdLuongHTNV": number[];
    "dsIdLuongBSTBKS": number[];
    "dsIdLuongThuLaoKCT": number[];
    "dsIdLuongPhuCapTGV": number[];
    "dsIdThueTNCN"?: number[];
    "dsIdThueKTX"?: number[];
    "dynamicColumnHeaders"?: DynamicColumnHeader[];
}

export interface DynamicColumnHeader {
    id: number;
    name: string;
    loai: number; // Loại thành phần: 1=KhenThuong, 2=LuongCoBan, 3=PhuCap, 4=ThemGio, 5=HTNV, 6=BSTBKS, 7=ThuLaoKCT, 8=PhuCapTGV, 9=BaoHiem, 12=ThueTNCN, 13=ThueKTX
    nhomCot: number; // 0 = Thu nhập chịu thuế, 1 = Giảm trừ (BHXH)
}

export class ChiTietLuongThangItem {
    "id": number;
    "idLuong": number;
    "idNhanVien": number;
    "idChucVu": number;
    "luongDuocNhan"?: number;
    "tienThueTNCN"?: number;
    "luongSauThue"?: number;
    "ghiChu"?: string;

    "ma"?: string;
    "hoTen"?: string;
    "tenChucVu"?: string;
    "tenDonVi"?: string;
    "idNhomNhanSu": number;
    "isQuanLy": boolean;
    "dynamicColumns"?: { [key: string]: number };
}

export class KhoanThuNhapLuongThangItem {
    "loai": number;
    "tenKhoan": string;
    "soTien": number;
}

export interface ChiTietThuNhapBangItem {
    tt: string;
    noiDung: string;
    chiTiet?: string | number;
    soTien?: number;
    isHeader?: boolean;
    level?: number;
}

export class ThuNhapLuongThangInfo {
    "tenKyLuong": string;
    "dsKhoan": KhoanThuNhapLuongThangItem[];
    "dsChiTietBang"?: ChiTietThuNhapBangItem[];
    "tongThuNhap": number;
    "tienThueTNCN"?: number;
    "thucNhan"?: number;
    "ghiChu"?: string;
}

